import { TableRow, TableCell } from '@mui/material';
import { Loader } from '@/components/atoms';

export interface LoadingStateProps {
  columnsCount: number;
}

/**
 * LoadingState - Displays a loading spinner while data is being fetched
 *
 * Features:
 * - Centered loading spinner
 * - Spans across all table columns
 * - Proper styling and spacing
 *
 * Can be reused in other parts of the application where loading states are needed
 */
export const LoadingState = ({ columnsCount }: LoadingStateProps) => {
  return (
    <TableRow>
      <TableCell colSpan={columnsCount} variant="loading">
        <Loader size={24} />
      </TableCell>
    </TableRow>
  );
};
